import React from 'react';
import { Button, Flex } from '@chakra-ui/react';

const PlanTypeTabs = ({ planTab, onChange, mb = 6 }) => (
	<Flex
		justify='center'
		gap={2}
		p={1.5}
		bg='gray.100'
		borderRadius='full'
		border='1px solid'
		borderColor='gray.200'
		w='fit-content'
		mx='auto'
		mb={mb}>
		<Button
			variant={planTab === 'subscription' ? 'solid' : 'ghost'}
			colorScheme='teal'
			bg={planTab === 'subscription' ? 'white' : 'transparent'}
			color={planTab === 'subscription' ? 'gray.800' : 'gray.600'}
			boxShadow={planTab === 'subscription' ? 'sm' : 'none'}
			borderRadius='full'
			px={6}
			size='md'
			_hover={{ bg: planTab === 'subscription' ? 'white' : 'gray.200' }}
			onClick={() => onChange('subscription')}>
			Subscription
		</Button>
		<Button
			variant={planTab === 'lifetime' ? 'solid' : 'ghost'}
			colorScheme='orange'
			bg={planTab === 'lifetime' ? 'white' : 'transparent'}
			color={planTab === 'lifetime' ? 'gray.800' : 'gray.600'}
			boxShadow={planTab === 'lifetime' ? 'sm' : 'none'}
			borderRadius='full'
			px={6}
			size='md'
			_hover={{ bg: planTab === 'lifetime' ? 'white' : 'gray.200' }}
			onClick={() => onChange('lifetime')}>
			Lifetime access
		</Button>
	</Flex>
);

export default PlanTypeTabs;
